<script>
export default {
  name: "DidoApidocUsageErrors",
};
</script>

<script setup>
import DidoCodeHightlighting from "../codeHighlighting/Base.vue";

const codeExampleError = `
{
  "code": 400
  "message": "un message générique d'erreur",
  "errors": [{...},{...}]
}
`;
</script>

<template>
  <div class="q-mt-md line-height-15">
    La gestion d'erreurs de l'api utilise les codes d'erreur suivants :
    <ul class="error-code-list">
      <li><span class="text-bold">400</span> : requête invalide</li>
      <li><span class="text-bold">404</span> : ressource inexistante</li>
      <li><span class="text-bold">500</span> : erreur du serveur</li>
    </ul>
    Lorsque c’est possible, l’api répondra en JSON avec le format suivant :
    <!-- Highlighting code -->
    <DidoCodeHightlighting language="javascript" :code="codeExampleError" />
  </div>
</template>
